import React from 'react'
import tw, { styled } from 'twin.macro'

export const FilterGrid = ({ children, size = 4 }) => <Grid size={size}>{children}</Grid>

const Grid = styled.div`
  ${tw`relative grid gap-0.5 w-full grid-cols-4`}
  ${({ size }) => `grid-template-columns: repeat(${size}, minmax(0,1fr))`};
`
